import {
  loadFixture, paginate, nextId, parseBody, parseQuery, urlParam, groupIdentifierFromUrl,
  groupFixtureName,
} from '../mockDataStore';

const MEDIA_DETAIL = /^\/?api\/v1\/groups\/[\w-]+\/media\/(\d+)\/?$/;

export default function registerMediaMocks(mock) {
  mock.onGet(/^\/?api\/v1\/groups\/[\w-]+\/media\/?(\?.*)?$/).reply(async (config) => {
    const media = await loadFixture(groupFixtureName('media/media', groupIdentifierFromUrl(config.url)));
    const query = parseQuery(config.url);

    let filtered = media.results;
    if (query.file_type && query.file_type !== 'all') {
      filtered = filtered.filter((item) => item.file_type === query.file_type);
    } else if ('parent' in query) {
      const parentId = query.parent ? Number(query.parent) : null;
      filtered = filtered.filter((item) => item.parent === parentId);
    } else {
      filtered = filtered.filter((item) => item.parent === null);
    }

    return [200, paginate(filtered, query)];
  });

  mock.onPost(/^\/?api\/v1\/groups\/[\w-]+\/media\/?$/).reply(async (config) => {
    const media = await loadFixture(groupFixtureName('media/media', groupIdentifierFromUrl(config.url)));
    const body = parseBody(config);
    const created = {
      id: nextId(media.results),
      name: body.name,
      description: null,
      file_type: 'folder',
      parent: null,
      children_count: 0,
      folder_thumbnail_url: null,
    };
    media.results.push(created);
    media.count += 1;
    return [201, created];
  });

  mock.onPatch(/^\/?api\/v1\/groups\/[\w-]+\/media\/bulk_edit\/?$/).reply(async (config) => {
    const media = await loadFixture(groupFixtureName('media/media', groupIdentifierFromUrl(config.url)));
    const updates = parseBody(config);
    (Array.isArray(updates) ? updates : []).forEach((update) => {
      const item = media.results.find((entry) => entry.id === update.id);
      if (item) Object.assign(item, update);
    });
    return [200, media.results];
  });

  mock.onPatch(MEDIA_DETAIL).reply(async (config) => {
    const media = await loadFixture(groupFixtureName('media/media', groupIdentifierFromUrl(config.url)));
    const item = media.results.find((entry) => entry.id === Number(urlParam(config, MEDIA_DETAIL)));
    if (!item) return [404, { message: 'Not found.' }];
    Object.assign(item, parseBody(config));
    return [200, item];
  });

  mock.onPost(/^\/?api\/v1\/groups\/[\w-]+\/media\/move\/?$/).reply(async (config) => {
    const media = await loadFixture(groupFixtureName('media/media', groupIdentifierFromUrl(config.url)));
    const { folder_id: folderId, file_ids: fileIds } = parseBody(config);
    (fileIds || []).forEach((id) => {
      const item = media.results.find((entry) => entry.id === Number(id));
      if (item) item.parent = folderId ? Number(folderId) : null;
    });
    return [200, {}];
  });

  mock.onPost(/^\/?api\/v1\/groups\/[\w-]+\/media\/bulk_delete\/?$/).reply(async (config) => {
    const media = await loadFixture(groupFixtureName('media/media', groupIdentifierFromUrl(config.url)));
    const { file_ids: fileIds } = parseBody(config);
    const idsToDelete = new Set((fileIds || []).map(Number));
    media.results = media.results.filter((item) => !idsToDelete.has(item.id));
    media.count = media.results.length;
    return [200, {}];
  });

  // Real endpoint streams a ZIP; demo mode returns a small placeholder blob so the
  // download button in the UI produces a real, harmless file (see plan §8).
  mock.onPost(/^\/?api\/v1\/groups\/[\w-]+\/media\/download\/?$/).reply(() => [
    200,
    new Blob(['This is a placeholder file for the Reunacy demo environment.'], { type: 'application/zip' }),
  ]);
}
